/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-documents
 * crm-screener-documents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerGeneratedDocument } from './ScreenerGeneratedDocument';
import {
    ScreenerGeneratedDocumentFromJSON,
    ScreenerGeneratedDocumentFromJSONTyped,
    ScreenerGeneratedDocumentToJSON,
    ScreenerGeneratedDocumentToJSONTyped,
} from './ScreenerGeneratedDocument';

/**
 * 
 * @export
 * @interface EnqueueGenerateReport200Response
 */
export interface EnqueueGenerateReport200Response {
    /**
     * 
     */
    data?: ScreenerGeneratedDocument;
}

/**
 * Check if a given object implements the EnqueueGenerateReport200Response interface.
 */
export function instanceOfEnqueueGenerateReport200Response(value: object): value is EnqueueGenerateReport200Response {
    return true;
}

export function EnqueueGenerateReport200ResponseFromJSON(json: any): EnqueueGenerateReport200Response {
    return EnqueueGenerateReport200ResponseFromJSONTyped(json, false);
}

export function EnqueueGenerateReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnqueueGenerateReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScreenerGeneratedDocumentFromJSON(json['data']),
    };
}

export function EnqueueGenerateReport200ResponseToJSON(json: any): EnqueueGenerateReport200Response {
    return EnqueueGenerateReport200ResponseToJSONTyped(json, false);
}

export function EnqueueGenerateReport200ResponseToJSONTyped(value?: EnqueueGenerateReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ScreenerGeneratedDocumentToJSON(value['data']),
    };
}

